/* eslint-disable react/jsx-handler-names */
import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// @actions
import cardImagesActions from 'actions/cardImagesActions';
import creditCardActions from 'actions/creditCardActions';
import preLoaderActions from 'actions/preLoaderActions';

// @ components
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import CreditCardLimitCredit from 'components/CreditCardComponents/CreditCardLimitCredit/CreditCardLimitCredit';
import CreditCardIbanSale from 'components/CreditCardComponents/CreditCardIbanSale/CreditCardIbanSale';

// @ HOCs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

// @ constants
import { VIDEO, VIDEO_CALL, VIDEO_SELFIE, CIRBE } from 'constants/identityMethod';
import { LIMIT_CREDIT, EXTERNAL_IBAN } from 'constants/statusProcess';
import { BASIC as PARTNER_BASIC } from 'constants/creditCard/partners';

// @ utilities
import { i18n } from 'core/i18n';
import { checkAndCreateAttrbIfExistsIn } from 'utilities/userProfile';

// @icons
import { getCreditCardImage } from 'utilities/creditCard/creditCard';

const { FormattedText } = i18n;

class CreditCardConfiguration extends Component {
    state = {
        creditCardLimit: 0,
    };

    componentDidMount = () => {
        const {
            cardImages,
            cardImagesActions: { getCreditCardImageAction },
            creditCardActions: { getCreditCardLimit, executeCirbeRequest },
            preLoaderActions: { hidePreLoader, showPreLoader },
            userProfile: { status, accessToken },
            setCreditCardPdf,
            handleDisableNextButton,
            flags,
        } = this.props;

        let withPdf = true;

        setTimeout(() => {
            showPreLoader();
        }, 200);

        if (!cardImages.get('cardImagesArray').size) getCreditCardImageAction();
        if (status !== LIMIT_CREDIT) handleDisableNextButton(true);
        if (status === EXTERNAL_IBAN) withPdf = false;

        getCreditCardLimit(accessToken).then(async creditCardLimit => {
            this.setState({ creditCardLimit });
            flags.get(CIRBE) && (await executeCirbeRequest(accessToken));
            withPdf && (await setCreditCardPdf());
            setTimeout(() => hidePreLoader(), 200);
        });
    };

    render = () => {
        const { userProfile, ibanPollingStatus, partner } = this.props;
        const { creditCardLimit } = this.state;

        const imageCard = getCreditCardImage(partner ? partner.get('id') : PARTNER_BASIC);
        const showIbanCredit = checkAndCreateAttrbIfExistsIn(userProfile.identityMethod, {
            VIDEO,
            VIDEO_CALL,
            VIDEO_SELFIE,
        });

        return (
            <React.Fragment>
                <section className={'row open-credit-sale'}>
                    <div className="persona-data-view">
                        <div className="col-xs-12 col-sm-4">
                            <img src={imageCard} className="open-credit-sale__img" />
                        </div>

                        <div className="col-xs-12 col-sm-8 open-credit-sale__padding">
                            <CreditCardLimitCredit limit={creditCardLimit} />
                            <div className="open-credit-sale__cms">
                                <FormattedText
                                    value={`creditCardOffer-configurationCardCMSTitle_${
                                        partner ? partner.get('id') : PARTNER_BASIC
                                    }`}
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <ConditionalToggling condition={showIbanCredit[userProfile.identityMethod]}>
                    <CreditCardIbanSale
                        ibanPollingStatus={ibanPollingStatus}
                        handleDisableNextButton={this.props.handleDisableNextButton}
                    />
                </ConditionalToggling>
            </React.Fragment>
        );
    };
}

export default connect(
    state => ({
        userProfile: state.userProfile,
        cardImages: state.cardImages,
        partner: state.products.get('partner'),
    }),
    dispatch => ({
        cardImagesActions: bindActionCreators(cardImagesActions, dispatch),
        creditCardActions: bindActionCreators(creditCardActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(withFeatureToggling(CreditCardConfiguration));
